import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { useLanguage } from '../../../../contexts/LanguageContext';

const VorTable = ({ requests, loading, totalCount, pagination, onPageChange, onEdit }) => {
  const { th, getCurrentLanguageId } = useLanguage();

  const localeByLangId = (langId) => {
    switch (langId) {
      case 1: return 'tr-TR';
      case 2: return 'en-US';
      case 3: return 'de-DE';
      default: return 'tr-TR';
    }
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <Button
        icon="pi pi-pencil"
        className="p-button-rounded p-button-warning p-button-sm"
        onClick={() => onEdit(rowData)}
        tooltip={th('vor.edit')}
        tooltipOptions={{ position: 'top' }}
      />
    );
  };

  const dateBodyTemplate = (rowData, field) => {
    const date = rowData[field.field];
    if (!date) return '-';
    const locale = localeByLangId(getCurrentLanguageId());
    return new Date(date).toLocaleDateString(locale);
  };

  return (
    <DataTable
      value={requests}
      loading={loading}
      paginator
      rows={pagination.pageSize}
      totalRecords={totalCount}
      lazy
      first={(pagination.pageNumber - 1) * pagination.pageSize}
      onPage={(e) => onPageChange(e.page + 1, e.rows)}
      rowsPerPageOptions={[10, 25, 50]}
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      currentPageReportTemplate="{first} - {last} / {totalRecords}"
      emptyMessage={th('vor.emptyMessage')}
      className="p-datatable-sm"
    >
      <Column field="id" header={th('vor.columnHeaders.requestNo')} sortable style={{ width: '100px' }} />
      <Column field="chassisNo" header={th('vor.columnHeaders.chassisNo')} sortable />
      <Column field="errorNotificationDate" header={th('vor.columnHeaders.notificationDate')} body={dateBodyTemplate} sortable />
      <Column field="dealerName" header={th('vor.columnHeaders.dealerName')} sortable />
      <Column field="vehicleModelEmissions" header={th('vor.columnHeaders.vehicleModel')} sortable />
      <Column
        body={actionBodyTemplate}
        header={th('vor.columnHeaders.actions')}
        style={{ width: '120px', textAlign: 'center' }}
        frozen
        alignFrozen="right"
      />
    </DataTable>
  );
};

export default VorTable;
